import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  AttachmentAppEntityApplicationRead, AttachmentAppEntityShipmentRead
} from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { UploaderAttachmentsService } from '../../../../../../../services/uploader-attachments.service';
import { Store } from '@ngrx/store';
import { AttachmentPositions } from '../../../../../../../services/application.common.model';
import { selectServiceAttachmentPositions } from '../../../../../../../store/selectors/application.selectors';
import { AttachmentInfoComponent } from '../attachment-info/attachment-info.component';

@Component({
  selector: 'app-attachments-data-preview',
  standalone: true,
  imports: [
    CommonModule,
    AttachmentInfoComponent
  ],
  templateUrl: './attachments-data-preview.component.html'
})
export class AttachmentsDataPreviewComponent {

  public attachmentsPositions: Signal<AttachmentPositions> = this.store$.selectSignal(selectServiceAttachmentPositions);

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public attachments: Signal<Array<AttachmentAppEntityApplicationRead | undefined>> = computed(() => this.application()?.attachments?.map((v) => v?.attachment) || []);

  constructor(
    private uploaderService: UploaderAttachmentsService,
    private store$: Store
  ) {
  }

  public getAttachmentsByTag(tag: string): Array<AttachmentAppEntityShipmentRead | undefined> {
    return this.attachments().filter(v => v?.tag === tag);
  }

  public onDownloadFile(event: Event, id?: string, name?: string): void {
    event.preventDefault();
    event.stopPropagation();
    if (id) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }
}

